var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.storeFeatureLoadable)?_c('iframe',{attrs:{"src":("https://player.vimeo.com/video/" + _vm.videoId + "?dnt=1"),"frameborder":"0","allowfullscreen":"","webkitallowfullscreen":"","mozallowfullscreen":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }